import { render } from "./FacilityTopSectionsChart.vue?vue&type=template&id=2ea64196&scoped=true"
import script from "./FacilityTopSectionsChart.vue?vue&type=script&lang=js"
export * from "./FacilityTopSectionsChart.vue?vue&type=script&lang=js"

import "./FacilityTopSectionsChart.vue?vue&type=style&index=0&id=2ea64196&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2ea64196"

export default script